<template>
  <div class="home">
    <van-nav-bar title="专家认证" fixed/>
    <div class="expert-result">
      <div class="expert-result-img">
        <img v-if="state==1" class="portrait" src="../assets/expertregisterimg/icon-4.png">
        <img v-if="state==2" class="portrait" src="../assets/expertregisterimg/icon-5.png">
        <img v-if="state==3" class="portrait" src="../assets/expertregisterimg/icon-6.png">
      </div>
      <div class="expert-result-title" v-if="state==1">申请提交成功</div>
      <div class="expert-result-title" v-if="state==2">专家认证审核中</div>
      <div class="expert-result-title" v-if="state==3">您已是平台专家</div>
      <div class="expert-result-text" v-if="state==1 || state==2">
        <p>专家身份审核日期为1-3个工作日，</p>
        <p>下载中科名兽医app后可查看进度。</p>
      </div>
      <div class="expert-result-text" v-if="state==3">
        <p>可通过开启App设置后，进行服务。</p>
      </div>
      <div class="expert-result-button">
        <div class="msgbox-botton" v-if="openPopup == true">
          <span>打开中科名兽医APP</span>
          <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
            <script type="text/wxtag-template">
              <style>.btn {height: 45px;}</style>
              <div class="btn">打开APP</div>
            </script>
          </wx-open-launch-app>
        </div>
        <div class="dowapp" v-else @click="dowapp">下载中科名兽医app</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant'
  import { wechaturl } from '@/api/path.js'
  import { iswx, wxshare } from '@/utils/utils.js'
  export default {
    name: 'expertregister',
    data() {
      return {
        state: '',   
        img: 'https://zkjy.oss-cn-beijing.aliyuncs.com/2021/share/expertregister.png',
        title: '立即申请，成为中科名兽医平台共享专家。',
        desc: '诚邀全国畜牧业相关专家，在线提供及时、便捷、高效的专业化服务。',
        wechaturl: wechaturl,
        url: wechaturl+'expertlogin',
        openPopup: false,
        id: 'wxopenLanchAppId',
        appid: 'wxdc89dd9a7329fe47',
        wechatOpenAppData: '',
      }
    },
    created(){
      this.state = this.$route.query.state
      localStorage.removeItem('uToken')
      localStorage.removeItem('eToken')
      localStorage.removeItem('userId')
      wxshare(this.img,this.title,this.desc,this.url)
      let json = {
        "type": "certification",
        "linkId": ''
      }
      this.wechatOpenAppData = JSON.stringify(json)
      if (iswx() === true) {
        let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
        console.log('wechat',wechat)
        let judgewechat = wechat[1].split('.')
        // this.text = judgewechat
        if (judgewechat[0]>=8) {
          this.openPopup = true
        } else if(judgewechat[0]>=7){
          if(judgewechat[1]>=0){
              this.text = judgewechat
            if(judgewechat[2]>=12){
              this.openPopup = true
              console.log("当前符合 h5 打开指定app")                    
            }
          }
        }
      }
    },
    // vue设置页面背景色
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
      if (this.openPopup == true) {
        var btn = document.getElementById(this.id)
        btn.addEventListener('launch', e => {
          console.log('success');
        });
        btn.addEventListener('error',  e => {
          this.text = e.detail.errMsg
          if (e.detail.errMsg == 'launch:fail') {
            window.location = 'http://t.cn/Aijv8II4'
          } else {
            this.$createToast({
              txt: e.detail,
              type: 'error'
            }).show()
          }
        });
      }
    },
    beforeDestroy() {
      document.querySelector('body').removeAttribute('style')
    },
    methods: {
      // 判断是否输入手机号
      onClickLeft() {

      },
      onClickRight() {

      },
      dowapp() {
        window.location = 'http://t.cn/Aijv8II4'
      }
    },
  }
</script>

<style lang="scss">
  .home {
    max-width: 3.8rem;
    margin: 0 auto;
  }
  .van-nav-bar--fixed {
    position: fixed;
    top: 0;
    left: 50%;
    margin-left: -1.9rem;
    width: 3.8rem;
  }
  .expert-result {
    margin-top: 0.55rem;
    padding: 0.6rem 0;
    background: #fff;
    text-align: center;
    .expert-result-img {
      img {
        width: 1rem;
        height: 1rem;
      }
    }
    .expert-result-title {
      padding: 0.2rem 0;
      font-size: 0.26rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      color: #181818;
    }
    .expert-result-text {
      p {
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #999999;
        line-height: 0.2rem
      }
    }
    .expert-result-button {
      .msgbox-botton {
        position: relative;
        display: inline-block;
        width: 2.1rem;
        height: 0.4rem;
        background: linear-gradient(315deg,#096fcb, #2784f8);
        border-radius: 0.2rem;
        font-size: 0.15rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 0.45rem;
        strong {
          margin-left: 0.2rem;
        }
        .launch-btn {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0;
        }
      }
      .dowapp {
        display: inline-block;
        width: 2.1rem;
        height: 0.4rem;
        line-height: 0.4rem;
        opacity: 1;
        background: linear-gradient(315deg,#096fcb, #2784f8);
        border-radius: 0.2rem;
        font-size: 0.16rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        backdrop-filter: blur(0.1rem);
      }
    }
  }
</style>